// src/components/OtpInput.tsx
import React, { FC, useRef, useEffect } from 'react';

interface OtpInputProps {
  length?: number;
  value: string;
  onChange: (val: string) => void;
}

const OtpInput: FC<OtpInputProps> = ({ length = 6, value, onChange }) => {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  // keep refs array in sync
  useEffect(() => {
    inputsRef.current = inputsRef.current.slice(0, length);
  }, [length]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    idx: number,
  ) => {
    const val = e.target.value.replace(/\D/, '');
    const chars = value.split('');
    chars[idx] = val;
    const newVal = chars.join('').slice(0, length);
    onChange(newVal);

    if (val && idx < length - 1) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    idx: number,
  ) => {
    if (e.key === 'Backspace' && !value[idx] && idx > 0) {
      const chars = value.split('');
      chars[idx - 1] = '';
      onChange(chars.join(''));
      inputsRef.current[idx - 1]?.focus();
    }
  };

  return (
    <div className='flex space-x-2 mt-4'>
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          type='text'
          maxLength={1}
          value={value[i] || ''}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          ref={(el) => {
            inputsRef.current[i] = el;
          }}
          className='
            w-12 h-12 border-b-2 border-gray-300
            focus:border-green-500 outline-none
            text-center text-xl
          '
        />
      ))}
    </div>
  );
};

export default OtpInput;
